// **********************************
// This function exposes localization methods
// to JavaScript, enabling the ability to lookup keystrings
// in localized formats.
//
// By: Joshua Cole
// Date: 2013-01-08
// **********************************

// This object is specifically for downloading the dictionary and interacting with it.
// The theory is that this happens once and all the functions interact with the cached dictionary.
Dictionary = function () {
    // Store the dictionary as an object for fast look up.
    // Since we're interacting with properties not an array.
    this.wordlist = {};
    this.Initialize();
}

Dictionary.prototype.Initialize = function () {

    // try getting anti-forgery token for Site first, then StandAlone
    // this is necessary to facilitate usage from both MET/TEAM itself and MET/CAL embedded browser dialogs
    var token = null;
    try {
        token = getSiteAntiForgeryTokenValue(); 
    }
    catch {
        try {
            token = getStandAloneAntiForgeryTokenValue();
        }
        catch { }
    }

    // Load the dictionary
    var request = $.ajax({
        url: '/Language/GetDictionary',
        data: {
            __RequestVerificationToken: token
        },
        type: 'post',
        async: false,
        dataType: 'json'
    });

    // Get the dictionary object.
    var obj = eval(request.response || request.responseText);
    if (obj !== undefined) {
        // Iterate over the object and build our dictionary.
        for (var i = 0; i < obj.length; i++) {
            var prop = (obj[i][0] || '').toLowerCase()
            this.wordlist[prop] = obj[i][1];
        }
    }
}

// This is a special function used for looking up the 'ENGLISH' value for any key in the system.
function ___ENFaster(key) {
    key = $.trim((key || '').toString().toLowerCase());
    var d = app.dictionary;
    var result = [];
    if (d !== undefined) {
        var wordlist = d.wordlist;
        if (wordlist !== undefined) {
            for (var prop in wordlist) {
                if ($.trim(wordlist[prop].toString().toLowerCase()) === key) {
                    result[result.length] = prop;
                }
            }
        }
    }
    if (result.length > 0) {
        return result;
    } else {
        result[0] = key;
        return result;
    }
}

// This is the translate helper function.
function ___(key) {
    if (app !== undefined) {
        if (app.dictionary !== undefined && key !== undefined) {
            var prop = key.toLowerCase();
            return app.dictionary.wordlist[prop] || key;
        }
    }
    return key;
}

function Translate(key) {
    return ___(key);
}

function TDIV(div_id) {
    var key = $("#" + div_id).text();
    $("#" + div_id).html(___(key));
}